import { Card, Col } from "reactstrap";
import ListOfBlogWithoutDetails from "./ListOfBlogWithoutDetails";
import { Image } from "../../../../AbstractElements";
import { BLOG_DATAS } from "../../../../Data/Blog";
import { dynamicImage } from "../../../../Service/DynamicImage";

const BlogWithoutDetails = () => {
  return (
    <>
      {BLOG_DATAS.map((data, index) => (
        <Col md="6" xl="3" className="box-col-3" key={index}>
          <Card>
            <div className="blog-box blog-grid text-center">
              <Image className="img-fluid top-radius-blog rounded-top-3" src={dynamicImage(`blog/${data}`)} alt="blog" />
              <ListOfBlogWithoutDetails />
            </div>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default BlogWithoutDetails;
